import React from 'react';

const DiscordIcon: React.FC<{ size?: number }> = ({ size = 32 }) => (
  <img
    src="/discord.png"
    alt="Discord"
    width={size}
    height={size}
    style={{ borderRadius: 8, display: 'inline-block', background: '#5865F2' }}
  />
);

export default DiscordIcon; 